export const ONLY_PLATFORM_LOCATION = 'ONLY_PLATFORM_LOCATION'
export const ONLY_SELF_SERVE_LOCATION = 'ONLY_SELF_SERVE_LOCATION'

export const CREATED_BY_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Platform', value: ONLY_PLATFORM_LOCATION },
  { label: 'Self-Serve', value: ONLY_SELF_SERVE_LOCATION },
]
export const BOOLEAN_OPTIONS = [
  { label: 'All', value: null },
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
]
export const TIMES_OF_DAY_OPTIONS = [
  { label: 'All', value: 'All' },
  { label: 'Morning', value: 'Morning' },
  { label: 'Lunch', value: 'Lunch' },
  { label: 'Afternoon', value: 'Afternoon' },
]

export const timeOfDayMapToFilter = {
  Morning: 'MORNING',
  Lunch: 'LUNCH',
  Afternoon: 'AFTERNOON',
}
